//# sourceMappingURL=text-reference.interface.js.map


//////////////////
// WEBPACK FOOTER
// ./~/pdfmake-wrapper/lib/interfaces/text-reference.interface.js
// module id = 1190
// module chunks = 4